<div class="wrapper-upload-file">
    <div>
        <img
            draggable="false"
            src="assets/images/logo-blue.svg"
            alt="H.ai"
            title="H.ai"
            class="logo"
        />
    </div>
    <div class="upload-container">
        <h2>Anexar exames</h2>

        <label class="custom-file-upload">
            Selecionar arquivo
            <input type="file" (change)="onFileSelected($event)" />
        </label>

        <div *ngIf="selectedFile" class="file-info">
            <p><strong>Selecionado:</strong> {{ selectedFile.name }}</p>
        </div>

        <button class="btn" (click)="onUpload()" [disabled]="!selectedFile || loading">
            {{ loading ? 'Enviando...' : 'Enviar' }}
        </button>

        <div *ngIf="uploadedFiles.length > 0" class="uploaded-list">
            <h3>Exames anexados:</h3>
            <ul>
                <li *ngFor="let file of uploadedFiles">{{ file }}</li>
            </ul>
        </div>
    </div>
</div>
